import React, {useState} from 'react';
import {useIntl} from 'react-intl';
import {Button} from "react-bootstrap";
import can from "../../../../_common/components/Permissions/can";
import {toAbsoluteUrl} from "../../../../../../_metronic/_helpers";
import {copyToClipboard} from '../../../../../../utils';

const PartnersLink = ({link}) => {
  const [showLink, setShowLink] = useState(false);
  const buttonClassName = `btn btn-icon h-40px btn-light btn-sm mx-3 custom-action-button
                           ${(can('full', 'partners'))
    ? ``
    : `cursor-default custom-disabled-button`}`;
  const intl = useIntl();
  const tooltip = intl.formatMessage({
    id: 'partners-popup-manage-column-link',
    defaultMessage: 'Show link',
  });

  return (
    <div className="text-dark-75 font-weight-bold d-block">
      {
        !showLink && (
          <Button
            variant="outline-primary"
            className={buttonClassName}
            title={tooltip}
            onClick={() => setShowLink(true)}
            disabled={!(can('full', 'partners'))}
          >
            <img
              src={toAbsoluteUrl('/media/svg/Link_brandColor.svg')}
              alt="show link"
              className={'h-20px'}
            />
          </Button>
        )
      }
      <div>
        {
          showLink
            ? (
              <div className={'h-40px d-flex align-items-center justify-content-center'}>
                <span
                  className={'limited-content-width-link'}
                  title={link}
                >
                  {link}
                </span>
                <img
                  src={toAbsoluteUrl('/media/svg/CopyLink_brandColor.svg')}
                  alt="copy"
                  className={'h-30px cursor-pointer'}
                  onClick={() => {
                    setShowLink(false);
                    copyToClipboard(link)
                  }}
                />
              </div>
            )
            : null
        }
      </div>
    </div>
  );
};

export default PartnersLink;
